<template>
    <template v-if="sending">
        <button :id="idName"
                type="button"
                :class="buttonClass"
                disabled>
            {{ updatingLabel }}...
            <i v-if="!!icon"
               :class="icon" />
        </button>
    </template>
    <template v-else>
        <button :id="`${idName}-update-button`"
                type="button"
                :class="buttonClass"
                :disabled="disabled"
                @click="buttonPressed">
            {{ buttonLabel }}
            <i v-if="!!icon"
               :class="icon" />
        </button>
    </template>
</template>

<script setup>
    import { ref, defineProps, defineEmits, computed } from 'vue';

    const props = defineProps({
        buttonLabel: {
            type: String,
            default: ''
        },
        sending: {
            type: Boolean,
            default: false
        },
        formatting: {
            type: String,
            default: 'btn btn-primary btn-sm btn-dark-color'
        },
        icon: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        defaultButton: {
            type: Boolean,
            default: true
        },
        updatingLabel: {
            type: String,
            default: "Updating"
        },
        idName: {
            type: String,
            default: "update"
        }
    });

    const emit = defineEmits(['click']);

    const buttonClass = computed(() => props.formatting + ((props.defaultButton) ? " default-button" : ""));


    function buttonPressed() {
        emit('click');
    }


</script>

<style scoped>
</style>